export default __webpack_public_path__ + "static/media/wallet-blue.005ea286.svg";